import { Component, OnInit } from '@angular/core';
import { ReportAttachment } from '../../models/report.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { NotifierService } from 'angular-notifier';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-reportattachments',
  templateUrl: './reportattachments.component.html',
  animations: [
    trigger('rowExpansionTrigger', [
      state(
        'void',
        style({
          transform: 'translateX(-10%)',
          opacity: 0
        })
      ),
      state(
        'active',
        style({
          transform: 'translateX(0)',
          opacity: 1
        })
      ),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ],
  styleUrls: ['./reportattachments.component.css']
})
export class ReportattachmentsComponent implements OnInit {
  uploadAttachmentList: ReportAttachment[] = [];
  reportAttachmentList: ReportAttachment[] = [];
  reportState: string;
  reportMetadataId: any;
  isLocked: boolean = false;
  loading: boolean;

  constructor(private reportDashboardService: ReportdashboardService, private notifier: NotifierService) {}

  ngOnInit() {
    this.reportAttachmentList = [];
  }

  ShowAttachmentsDialog(reportMetadataId: any, reportState: string) {
    this.reportAttachmentList = [];

    this.reportState = reportState;
    this.reportMetadataId = reportMetadataId;
    this.loading = true;
    //setTimeout(() => {
    this.reportDashboardService
      .getReportAttachments$(reportMetadataId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(data => {
        this.reportAttachmentList = data;
      });
    this.reportDashboardService.checkForLock(reportMetadataId).subscribe((data: boolean) => {
      this.isLocked = data;
      //console.log(data);
    });

    // },5000);
  }

  async onUpload(event, form) {
    var formData = new FormData();
    for (let file of event.files) {
      if (this.reportAttachmentList.length > 0) {
        if (this.reportAttachmentList.filter(x => x.attachmentName == file.name).length > 0) {
          this.clearFiles(form);
          this.notifier.notify('error', 'Attachment already exists');
          return;
        }
      }
      formData.append('files', file, file.name);
    }
    this.reportDashboardService.uploadAttachments$(this.reportMetadataId, formData).subscribe(
      resp => {
        console.log(resp);
        this.reportDashboardService.getReportAttachments$(this.reportMetadataId).subscribe(data => {
          this.reportAttachmentList = data;
        });
        this.notifier.notify('success', 'Attachment(s) added successfully');
        this.clearFiles(form);
      },
      (error: any) => {
        this.clearFiles(form);
        console.log(error);
        this.notifier.notify('error', 'Something went wrong, Please contact System Administrator');
      }
    );
  }

  clearFiles(form) {
    this.uploadAttachmentList = [];
    form.clear();
  }
  openAttachment(Id: number, fileName: string) {
    var fileType = fileName.split('.', 2)[1].toString();
    this.reportDashboardService.openAttachment$(Id, fileType).subscribe((content: Blob) => {
      const fileURL = URL.createObjectURL(content);
      //setTimeout(() => window.open(fileURL, '_blank'), 1000);
      var anchor = document.createElement('a');
      anchor.download = fileName;
      anchor.href = fileURL;
      anchor.click();
    });
  }
  deleteAttachment(reportAttachment: ReportAttachment) {
    this.reportDashboardService.deleteAttachment$(reportAttachment.id, this.reportMetadataId).subscribe(resp => {
      if (resp.ok) {
        this.reportAttachmentList.splice(this.reportAttachmentList.indexOf(reportAttachment), 1);
        this.notifier.notify('success', 'Attachment removed successfully');
      } else {
        this.notifier.notify('error', 'Something went wrong, Please contact System Administrator');
      }
    });
  }
}

// async onUpload(event, form) {

// for (let file of event.files) {

//     if(this.reportAttachmentList.length >0)
//     {
//        if(this.reportAttachmentList.filter(x=>x.attachmentName == file.name).length >0)
//        {
//          this.notifier.notify('error','Attachment already exists');
//          return;
//        }
//       //  if(file.name.length > 700000)
//       //  {
//       //    this.notifier.notify('error','File Name is too Long');
//       //    return;
//       //  }
//     }

//     //  const readUploadedFileAsArrayBuffer = (inputFile) => {
//     //   const temporaryFileReader = new FileReader();

//     //   return new Promise((resolve, reject) => {
//     //     temporaryFileReader.onerror = () => {
//     //       temporaryFileReader.abort();
//     //       reject("Problem parsing input file.");//new DOMException("Problem parsing input file.")
//     //     };

//     //     temporaryFileReader.onload = () => {
//     //       resolve(temporaryFileReader.result);
//     //     };
//     //     temporaryFileReader.readAsArrayBuffer(inputFile);
//     //   });
//     // };

//     // const fileContent = await readUploadedFileAsArrayBuffer(file);
//     // this.uploadAttachments(file,fileContent);

//   }

//   this.reportDashboardService.uploadAttachments$(this.uploadAttachmentList).subscribe((resp)=>{
//     if(resp.ok)
//     {
//       this.reportAttachmentList =resp.body;
//      this.notifier.notify('success','Attachment added successfully');
//     }
//     else{
//       this.notifier.notify('error','Something went wrong, Please contact System Administrator');

//     }
//     this.clearFiles(form);
//     this.uploadAttachmentList=[];
//   });

// }
// uploadAttachments(file,fileContent)
// {
//   var fileBuffer = new Uint8Array(fileContent);
//   var content :any[]=[];
//   if (fileBuffer) {
//     var byteArray = new Uint8Array(fileBuffer);
//     for (var i = 0; i < byteArray.byteLength; i++) {
//       content.push(byteArray[i]);
//     }
//   }
//   this.uploadAttachmentList.push({
//     id: 0,
//     reportMetadataId:this.reportMetadataId,
//     attachmentName:file.name,
//     attachmentContent:content
//     });

//   console.log(this.uploadAttachmentList);

// }



// WEBPACK FOOTER //
// ./src/app/reportdashboard/reportattachments/reportattachments.component.ts